import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { Department } from '@app/_models/_DTOs/department';
import { DepartmentService } from '@app/_services/department.service';

@Component({
    selector: 'app-department-selector',
    templateUrl: './department-selector.component.html',
    styleUrls: ['./department-selector.component.css']
})
export class DepartmentSelectorComponent extends EntitySelectorComponent<Department> {


    constructor(
        private departmentService: DepartmentService
    ) {
        super(departmentService);
    }
}